import Cookies from 'js-cookie';
import * as actionTypes from '../actions/actionTypes';

const initialState = {
  user: {},
  token: Cookies.get('token') || null,
  company: '', ///JUST SUPER ADMIN USERS HAS THE COMPANY ATTRIBUTE, WE USE THIS FOR SHOWING SOME THINGS IN SETTINGS PAGES
  hasMultiStore: false,
  role: '',
  isCompanyAdmin: false,
  cashierBox: '',
  store: '',
  name: '',
  stripeCustomerId: '',
  permission: {},
  intercom: null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_USER:
      Cookies.set('token', action.token);
      return {
        ...state,
        token: action.token,
        user: action.user,
        company: action.company,
        hasMultiStore: action.hasMultiStore,
        role: action.role,
        isCompanyAdmin: action.isCompanyAdmin,
        cashierBox: action.cashierBox,
        store: action.store,
        name: action.name,
        stripeCustomerId: action.stripeCustomerId,
        permission: action.permission,
        intercom: action.intercom
      };
    case actionTypes.SWITCH_USER:
      Cookies.set('token', action.token);
      Cookies.set('stripeCustomerId', action.stripeCustomerId);
      Cookies.set('currencySymbol', action.currencySymbol);
      return {
        ...state,
        token: action.token,
        user: action.user,
        company: action.company,
        hasMultiStore: action.hasMultiStore,
        role: action.role,
        isCompanyAdmin: action.isCompanyAdmin,
        cashierBox: action.cashierBox,
        store: action.store,
        name: action.name,
        stripeCustomerId: action.stripeCustomerId,
        permission: action.permission,
        intercom: action.intercom
      };
    case actionTypes.SET_SESSION_TOKEN:
      Cookies.set('token', action.token);
      return { ...state, token: action.token };
    case actionTypes.SET_INTERCOM_TOKEN:
      return {
        ...state,
        intercom: action.intercom
      };
    case actionTypes.SET_USER_PRINTER:
      Cookies.set('printer', action.printer?.name);
      localStorage.setItem('printer', action.printer?.name);
      Cookies.set('printerPaperSize', action.printer?.paperSize);
      localStorage.setItem('printerPaperSize', action.printer?.paperSize);
      return {
        ...state,
        user: {
          ...state.user,
          printer: {
            name: action.printer?.name,
            paperSize: action.printer?.paperSize
          }
        }
      };
    case actionTypes.SET_USER_COMPANY_INFO:
      return {
        ...state,
        company: {
          ...state.company,
          logoUrl: action.company?.logoUrl
        }
      };
    case actionTypes.CLEAR_USER:
      Cookies.remove('token');
      Cookies.remove('stripeCustomerId');
      Cookies.remove('currencySymbol');
      return {
        ...initialState,
        token: null
      };
    default:
      return state;
  }
};

export default reducer;
